module.exports = __webpack_public_path__ + "assets/images/alimentacao_saudavel.7fcd56b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alimentacao_saudavel.jpg
// module id = 803
// module chunks = 1